import { action, decorate, observable } from 'mobx';

import { formatPhoneNumber } from '../helper/functions';
import { getCashoutOptions, cashoutInitiate, cashoutExecute } from '../services/JualBitcoinService';
import { validateFormValuesUsingJoiSchema } from '../helper/validation';

const Joi = require('joi-browser');
Joi.objectId = require('joi-objectid')(Joi);

class JualBitcoinStore {
  formData = {};
  cashoutOptions = [];
  isLoading = false;
  cashoutResult = {};

  formValidationResult = {};

  getCashoutOptions = async via => {
    this.isLoading = true;
    const postData = {
      via: via,
    };
    const { data, error } = await getCashoutOptions(postData);

    if (data) {
      this.isLoading = false;
      this.cashoutOptions = data;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };

  cashoutInitiate = async walletId => {
    this.isLoading = true;

    const postData = {
      wallet: {
        address: walletId,
        currency: 'BTC',
        phoneNumber: formatPhoneNumber(this.formData['phone_number']),
      },
      product: {
        amount: this.formData['amount'],
        via: this.formData['receiveMethod'],
      },
    };

    const { data, error } = await cashoutInitiate(postData);

    if (data) {
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };

  cashoutExecute = async ({ walletId, otpCode }) => {
    this.isLoading = true;

    const postData = {
      wallet: {
        address: walletId,
        currency: 'BTC',
        phoneNumber: formatPhoneNumber(this.formData['phone_number']),
      },
      product: {
        amount: this.formData['amount'],
        via: this.formData['receiveMethod'],
      },
      otpCode: otpCode,
    };

    const { data, error } = await cashoutExecute(postData);

    if (data) {
      this.cashoutResult = data;
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };

  setFormData = updatedData => {
    this.formData = {
      ...this.formData,
      ...updatedData,
    };
  };

  validateForm = ({ min, max }) => {
    const joiSchema = {
      receiveMethod: Joi.string()
        .label('Metode Penarikan')
        .required(),
      amount: Joi.number()
        .integer()
        .min(min)
        .max(max)
        .label('Jumlah Penarikan')
        .required(),
    };
    this.formValidationResult = validateFormValuesUsingJoiSchema(this.formData, joiSchema);
    return this.formValidationResult;
  };
}

decorate(JualBitcoinStore, {
  isLoading: observable,
  formData: observable,
  cashoutOptions: observable,
  cashoutResult: observable,
  formValidationResult: observable,
  getCashoutOptions: action,
  cashoutInitiate: action,
  cashoutExecute: action,
});
export default new JualBitcoinStore();
